export default "__VITE_ASSET__CwBWDuJf__"